export default __webpack_public_path__ + "static/media/TF_17.fcf24193.png";